// extracted by mini-css-extract-plugin
export var homepageSliderWrap = "homepageSlider-module--homepage-slider-wrap--+JcX1";
export var homepageSliderWrapThree = "homepageSlider-module--homepage-slider-wrap-three--38Zpf";
export var homepageSliderWrapTwo = "homepageSlider-module--homepage-slider-wrap-two--Bw4Bl";
export var slide = "homepageSlider-module--slide--eTATa";